import { PrismicRichText } from '@prismicio/react';
import { PrismicNextImage } from '@prismicio/next';
import {
  ModalSliceLendersPrimary,
  Simplify,
} from '../../../../../prismicio-types';
import styles from './Lenders.module.scss';

interface Props {
  data: Simplify<ModalSliceLendersPrimary>;
}

const Lenders = ({ data }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        <PrismicRichText field={data.title} />
      </div>
      <div className={styles.lendersWrapper}>
        {data.lenders.map((logo, index) => (
          <PrismicNextImage
            fallbackAlt=""
            key={index}
            field={logo.image}
            className={styles.logo}
          />
        ))}
      </div>
    </div>
  );
};

export default Lenders;
